import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { useLetterActions } from 'assets/js/pages/engage/letters/useLetterActions';

interface MarkLetterDialogProps extends AlertDialog.AlertDialogRootProps {
    isSending?: boolean;
    messageId: number;
}

const MarkLetterDialog = (props: MarkLetterDialogProps) => {
    const { isSending = true, messageId, children, ...rest } = props;
    const { markLetterAsSentMutation, markLetterAsUnsentMutation } = useLetterActions();
    const { isPending: isMarkingAsSent, mutate: markSent } = markLetterAsSentMutation;
    const { isPending: isMarkingAsUnsent, mutate: markUnsent } = markLetterAsUnsentMutation;
    const isLoading = isMarkingAsSent || isMarkingAsUnsent;

    const mark = () => {
        const nextMark = isSending ? markSent : markUnsent;

        return nextMark(messageId);
    };

    return (
        <AlertDialog.Root type={'warning'} {...rest}>
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>
                            {isSending ? 'Did you send your letters?' : 'Unmark letters as sent?'}
                        </AlertDialog.Title>
                        <AlertDialog.Description>
                            {isSending
                                ? `Marking a letter as 'sent' adds an activity record to each recipient's contact detail page for internal tracking purposes. This action doesn't modify a letter's content, notify donors, and is reversible at anytime.`
                                : `Unmarking a letter as 'sent' removes the activity record to each recipient’s contact detail page for internal tracking purposes. This action doesn't modify a letter's content, notify donors, and is reversible at anytime.`}
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel>Close</AlertDialog.Cancel>
                        <AlertDialog.Action disabled={isLoading} onClick={() => mark()}>
                            Confirm
                        </AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const MarkLetterDialogTrigger = AlertDialog.Trigger;

const Root = MarkLetterDialog;
const Trigger = MarkLetterDialogTrigger;

export {
    Root,
    Trigger,
    //
    MarkLetterDialog,
    MarkLetterDialogTrigger,
};
export type { MarkLetterDialogProps };
